import gql from 'graphql-tag'

export const LIST = gql`
  query company($filter: CompanyFilter, $offset: Int, $limit: Int!) {
    company(filter: $filter, offset: $offset, limit: $limit) {
      data {
        id title
      }
      total_count
    }
  }
`

export const MANAGERS = gql`
query managers($companyId: Int, $departmentId:Int, $limit: Int = 10000, $offset: Int = 0){
  managers(companyId: $companyId, departmentId: $departmentId, limit: $limit, offset: $offset){
    id
    name
  }
}
`
export const DEPARTMENTS = gql`
query departments($companyId: Int, $limit: Int = 10000, $offset: Int = 0){
  departments(companyId: $companyId, limit: $limit, offset: $offset){
    id
    name
  }
}
`
